import { PATHS, DIRECTORIES } from 'constants/pathsB2c';
import { getMainSubDirectory } from 'services/helpers/location';

export const getTabFromPath = (path: string) => {
  const mainSubDirectory = getMainSubDirectory(path);

  if (mainSubDirectory === DIRECTORIES.BAM_PLAYLISTS) return PATHS.WEB_PLAYER;
  if (mainSubDirectory === DIRECTORIES.MY_PLAYLISTS) return PATHS.MY_PLAYLISTS;
  return path;
};
